export const Balcony = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    // xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0"
    y="0"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
    // xml:space="preserve"
    enableBackground="new 0 0 24 24"
  >
    <g>
      <path
        d="M22.138 22.521H0.863v-1.821c0 -0.575 0.383 -0.958 0.958 -0.958h19.358c0.575 0 0.958 0.383 0.958 0.958v1.821z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1"
      ></path>
      <path
        d="M21.083 13.033H1.917c-0.575 0 -1.054 0.479 -1.054 1.054v0c0 0.575 0.479 1.054 1.054 1.054h19.167c0.575 0 1.054 -0.479 1.054 -1.054v0c0 -0.575 -0.479 -1.054 -1.054 -1.054z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1"
      ></path>
      <g>
        <path
          d="M6.037 13.033V7.858c0 -2.971 2.396 -5.367 5.367 -5.367s5.367 2.396 5.367 5.367v4.983"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1"
        ></path>
        <path
          d="M3.929 13.033V7.954C3.929 3.833 7.283 0.575 11.308 0.575s7.379 3.354 7.379 7.379v5.079"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1"
        ></path>
        <path
          d="m11.308 2.588 0 10.446"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1"
        ></path>
      </g>
      <g>
        <path
          d="m1.821 15.142 0 4.504"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1"
        ></path>
        <path
          d="m6.229 15.142 0 4.504"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1"
        ></path>
        <path
          d="m10.542 15.142 0 4.504"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1"
        ></path>
        <path
          d="m14.95 15.142 0 4.504"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1"
        ></path>
        <path
          d="m19.263 15.142 0 4.504"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1"
        ></path>
      </g>
      <g>
        <path
          d="m3.738 15.142 0 4.504"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1"
        ></path>
        <path
          d="m8.05 15.142 0 4.504"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1"
        ></path>
        <path
          d="m12.458 15.142 0 4.504"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1"
        ></path>
        <path
          d="m16.771 15.142 0 4.504"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1"
        ></path>
        <path
          d="m21.179 15.142 0 4.504"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1"
        ></path>
      </g>
      <path
        d="m16.675 7.858 -10.637 0"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1"
      ></path>
    </g>
  </svg>
);

export const Bathroom = () => (
  <svg
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.625 6.229V5.75a5.271 5.271 0 0 1 10.542 0v16.771"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M12.458 10.063a3.833 3.833 0 0 0 -7.667 0v0.479a0.479 0.479 0 0 0 0.479 0.479h6.708a0.479 0.479 0 0 0 0.479 -0.479Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m8.625 16.052 0 -1.917"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m8.625 21.802 0 -1.917"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m12.175 15.771 -0.733 -1.771"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m14.375 21.083 -0.733 -1.771"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m5.075 15.771 0.733 -1.771"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m2.875 21.083 0.733 -1.771"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const Garden = () => (
  <svg
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m11.5 22.521 0 -15.97"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M11.5 6.551s1.917 -1.237 1.917 -3.094a3.971 3.971 0 0 0 -1.62 -2.875 0.47 0.47 0 0 0 -0.595 0 3.97 3.97 0 0 0 -1.619 2.875c0 1.856 1.917 3.094 1.917 3.094Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M11.5 10.019s0.863 -3.87 5.839 -3.87a0.479 0.479 0 0 1 0.402 0.767A7.611 7.611 0 0 1 11.5 10.019Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M11.5 10.019s-0.863 -3.87 -5.839 -3.87a0.479 0.479 0 0 0 -0.402 0.767A7.611 7.611 0 0 0 11.5 10.019Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M11.5 14.811s1.734 -4.13 7.283 -3.067a0.479 0.479 0 0 1 0.251 0.822A8.486 8.486 0 0 1 11.5 14.811Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M11.5 14.811s-1.734 -4.13 -7.283 -3.067a0.479 0.479 0 0 0 -0.251 0.822A8.486 8.486 0 0 0 11.5 14.811Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M11.5 19.124s-2.652 -3.609 -7.8 -1.276a0.484 0.484 0 0 0 -0.052 0.863 8.484 8.484 0 0 0 7.852 0.413Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M11.5 19.124s2.652 -3.609 7.8 -1.276a0.484 0.484 0 0 1 0.052 0.863 8.484 8.484 0 0 1 -7.852 0.413Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const Kitchen = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <g>
      <path
        d="M1.438 11.155h20.125s0.958 0 0.958 0.958v0.958s0 0.958 -0.958 0.958h-20.125s-0.958 0 -0.958 -0.958v-0.958s0 -0.958 0.958 -0.958"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m2.396 20.738 0 -6.708"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m20.604 20.738 0 -6.708"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M4.313 19.78a0.958 0.958 0 0 0 0.958 0.958h3.833a0.958 0.958 0 0 0 0 -1.917h-3.833a0.958 0.958 0 0 0 -0.958 0.958Z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M12.938 19.78a0.958 0.958 0 0 0 0.958 0.958h3.833a0.958 0.958 0 0 0 0 -1.917h-3.833a0.958 0.958 0 0 0 -0.958 0.958Z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m11.979 11.145 -6.229 0 0.958 -6.708 4.313 0 0.958 6.708z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M6.708 4.447a2.156 2.156 0 1 1 4.313 0"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M4.073 8.759a1.198 1.198 0 0 1 0 -2.396h2.357"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M11.299 6.363h1.016a1.188 1.188 0 0 0 1.102 -0.671l0.537 -1.064a1.179 1.179 0 0 1 1.073 -0.661h0.45"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M18.688 9.123a4.552 4.552 0 0 1 -0.479 2.032h-2.875a4.552 4.552 0 0 1 -0.479 -2.032V7.801a0.479 0.479 0 0 1 0.479 -0.479h2.875a0.479 0.479 0 0 1 0.479 0.479Z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
    </g>
  </svg>
);

export const LivingRoom = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <defs></defs>
    <title>indooor-plant-14</title>
    <path
      d="M3.009 20.317c0.072 0.54 0.404 0.931 0.792 0.931h3.497c0.383 0 0.721 -0.391 0.792 -0.931l0.907 -5.254a1.18 1.18 0 0 0 -0.643 -1.331 0.561 0.561 0 0 0 -0.149 -0.02h-5.309c-0.446 0 -0.806 0.511 -0.806 1.14a1.706 1.706 0 0 0 0.013 0.211Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M6.838 13.715c0.14 -1.394 0.317 -3.286 0.479 -4.232A13.157 13.157 0 0 1 8.633 5.558"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M6.313 4.457C5.046 6.708 5.463 8.449 6.775 9.188s3.02 0.192 4.287 -2.053 1.231 -4.669 -0.081 -5.409 -3.402 0.484 -4.669 2.731Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M4.923 10.183a1.998 1.998 0 0 1 -0.308 0.214c-1.064 0.599 -2.449 0.158 -3.477 -1.665s-0.998 -3.786 0.066 -4.386a2.32 2.32 0 0 1 2.553 0.671"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M10.275 18.703a2.859 2.859 0 0 0 1.796 0.631h7.667a2.875 2.875 0 0 0 2.875 -2.875v-2.875a1.438 1.438 0 1 0 -2.875 0v1.438a0.719 0.719 0 0 1 -0.719 0.719h-6.229a0.719 0.719 0 0 1 -0.719 -0.719v-1.438a1.473 1.473 0 0 0 -2.44 -1.091"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m12.071 19.333 0 2.156"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m19.259 19.333 0 2.156"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M10.614 12.146a4.313 4.313 0 0 1 4.313 -4.313H16.867a4.313 4.313 0 0 1 4.313 4.313"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M3.354 8.178a34.654 34.654 0 0 1 1.906 5.536"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const PrivateEntrance = () => (
  <svg
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.75 6.229a5.271 5.271 0 1 0 5.067 6.708H11.979l0.958 0.958 0.958 -0.958h0.958l0.958 0.958 0.958 -0.958H18.208l1.438 -1.438 -1.438 -1.438h-7.392A5.271 5.271 0 0 0 5.75 6.229Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M2.396 11.502a1.438 1.438 0 1 0 2.875 0 1.438 1.438 0 1 0 -2.875 0Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M10.063 18.709V21.563a0.958 0.958 0 0 0 0.958 0.958h10.542a0.958 0.958 0 0 0 0.958 -0.958v-20.125a0.958 0.958 0 0 0 -0.958 -0.958h-10.542a0.958 0.958 0 0 0 -0.958 0.958v3.833"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const Sink = () => (
  <svg
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.511 11.979V2.875a2.396 2.396 0 0 1 4.792 0v1.917"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M0.964 11.979a0.479 0.479 0 0 0 -0.479 0.496C0.739 18.067 5.75 22.521 11.511 22.521 17.25 22.521 22.261 18.067 22.521 12.476a0.479 0.479 0 0 0 -0.479 -0.496Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M17.74 8.625a1.438 1.438 0 0 1 -2.875 0 4.476 4.476 0 0 1 1.063 -1.948 0.479 0.479 0 0 1 0.749 0A4.461 4.461 0 0 1 17.74 8.625Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const StudyRoom = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <g>
      <path
        d="M1.438 3.354h10.542s0.958 0 0.958 0.958v6.708s0 0.958 -0.958 0.958h-10.542s-0.958 0 -0.958 -0.958v-6.708s0 -0.958 0.958 -0.958"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m8.146 14.854 -2.875 0 0.479 -2.875 1.917 0 0.479 2.875z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M22.521 16.292a1.438 1.438 0 0 1 -1.438 1.438H1.917a1.438 1.438 0 0 1 0 -2.875h19.167a1.438 1.438 0 0 1 1.438 1.438Z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M17.729 11.979h2.875v2.875h-2.875Z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m18.688 11.979 0 -1.917"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m19.646 11.979 1.438 -1.917"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m2.396 22.521 0 -4.792 1.917 0 0 4.792"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m19.646 22.521 0 -4.792 -1.917 0 0 4.792"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m18.688 2.396 0 1.917 1.438 0.958"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M14.854 4.313a3.833 3.833 0 1 0 7.667 0 3.833 3.833 0 1 0 -7.667 0"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m0.479 9.583 12.458 0"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
    </g>
  </svg>
);

export const Toilet = () => (
  <svg
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.313 16.771v-10.542c0 -3.176 1.501 -5.75 3.354 -5.75h11.5"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M15.813 6.229c0 3.176 1.501 5.75 3.354 5.75s3.354 -2.574 3.354 -5.75 -1.502 -5.75 -3.354 -5.75 -3.354 2.574 -3.354 5.75V19.167a3.334 3.334 0 0 1 -6.662 0.207 0.479 0.479 0 0 0 -0.69 -0.364L7.188 19.646l-2.218 -0.887a0.784 0.784 0 0 0 -0.455 0l-2.3 0.887 -1.037 -0.518a0.479 0.479 0 0 0 -0.656 0.617 6.406 6.406 0 0 0 3.13 2.779H12.458"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M18.207 6.229a0.958 1.917 0 1 0 1.917 0 0.958 1.917 0 1 0 -1.917 0Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m19.166 11.979 -3.354 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m6.707 6.229 0.958 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m12.457 6.229 0.958 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m9.582 6.229 0.958 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m6.707 13.896 0.958 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m12.457 13.896 0.958 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m9.582 13.896 0.958 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);
